<template>
<div>
    <h1>AdminServerTm</h1>

    <p>
        Как долго должен выполняться запрос на сервере
        <br /><input type="number" v-model="sec" > - количество секунд
        <br /><input type="checkbox" v-model="isPost"> - выполнить post
        <br /><button @click="doReq">выполнить sleep({{sec}})</button>

        <div v-if="req.wait">ждите....</div>

        <div v-if="!req.wait && (req.resolve || req.reject)">
            <div>ожидание фактически: {{Math.round( (req.finish - req.start)/1000 ) }} секунд</div>
            <div>ожидание по плану: {{sec}}</div>
            <div v-if="req.resolve"><b>выполнен sleep({{req.resolve.sec}})</b></div>
            <div v-else ><span style="color:#aa0000">ОШИБКА: {{req.reject}}</span></div>
        </div>
    </p>

</div>
</template>

<script setup>
import {unref, ref, watch, computed, onMounted, reactive} from 'vue'
import {adminServerTm} from '@/actions.js'

const sec = ref(1)
const isPost = ref(false)

const REQZ = {
    ok:false,
    wait: false,
    resolve: null,
    reject: null,
    start: 0,
    finish: 0,
}

const req = ref(REQZ)

const doReq = () => {
    if (req.wait) {
        return;
    }
    let start = Date.now()
    req.value = {...REQZ, wait: true, start}
    let sec1 = sec.value
    let isPost1 = isPost.value
    let postEmpty = isPost1
    adminServerTm({
        sec: sec1,
        isPost: isPost1,
        postEmpty, 
    }).then( resolve => {
        let finish = Date.now()
        req.value = {
            ok: true,
            wait: false,
            resolve,
            reject: null,
            start,
            finish,
        }
    }, reject => {
        let finish = Date.now()
        req.value = {
            ok: false,
            wait: false,
            resolve:null,
            reject,
            start,
            finish,
        }
    } )
}


</script>
